<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Watches />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Watches from "../../components/GestionEmpleados/Views/Employee/Watches.vue";
export default {
  components: { LandingToolbar, Watches },
};
</script>
